import { Button } from "@blueprintjs/core"
import { useState } from "react"
import { NAVIGATION_SIZE_TYPE } from "src/libs/useful/gallery/Gallery"
import { __ } from "src/libs/utilities"
import { ICWProps } from "."

/* Protopia Ecosystem component */ 
const NavSizeHandler = (props: ICWProps): JSX.Element => {
    const [ values, ] = useState<NAVIGATION_SIZE_TYPE[]>( Object.values( NAVIGATION_SIZE_TYPE).map( val => val ) )
    const onChange = () => {
        const index = values.findIndex(v => v ===  props.carousel_nav_size) || 0
        const next = (index + 1) % values.length
        props.onChange( {
            ...props,
            carousel_nav_size: values[next] 
        })
    }
    return <>
         <Button variant="minimal" size="small" className="btn-stretch px-2" onClick={onChange} >
            <div className="small" >
                { __( props.carousel_nav_size ) }
            </div>
        </Button> 
    </>
}
export default NavSizeHandler